module.exports = __webpack_public_path__ + "static/expertise-e2d9bf8ee4b9e36676c89d772ff21dec.svg";